export default __webpack_public_path__ + "static/media/team3.28b48597.png";